import React from "react";
import { Typography, Stack } from "@mui/material";

const ContactDetails = () => (
  <Stack gap="0.5rem">
    <Typography color="white" variant="body2">
      support@crossborderxpress.com
    </Typography>
  </Stack>
);

export default ContactDetails;
